__turbopack_context__.v({
  "copyBody": "e80P3G_copyBody",
  "copyHead": "e80P3G_copyHead",
  "ctaRow": "e80P3G_ctaRow",
  "deviceFrame": "e80P3G_deviceFrame",
  "eyebrow": "e80P3G_eyebrow",
  "fade-up": "e80P3G_fade-up",
  "float-in": "e80P3G_float-in",
  "hero": "e80P3G_hero",
  "heroInner": "e80P3G_heroInner",
  "lead": "e80P3G_lead",
  "portrait": "e80P3G_portrait",
  "portraitWrap": "e80P3G_portraitWrap",
  "socialLink": "e80P3G_socialLink",
  "socials": "e80P3G_socials",
  "tags": "e80P3G_tags",
  "visual": "e80P3G_visual",
});
